import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getDb, getAuthInstance } from './config.js';

const getUserId = () => {
    try {
        return getAuthInstance()?.currentUser?.uid || null;
    } catch (_) {
        return null;
    }
};

export const recordStudySession = async ({ folderId, folderName, studied, flagged, total, durationSec }) => {
    const userId = getUserId();
    if (!userId) return;
    const db = getDb();
    const doc = {
        userId,
        folderId,
        folderName,
        studied,
        flagged,
        total,
        durationSec: Number(durationSec) || null,
        createdAt: serverTimestamp()
    };
    await addDoc(collection(db, 'progress_study_sessions'), doc);
};

export const recordExamResult = async ({ examId, title, score, totalQuestions, percentage }) => {
    const userId = getUserId();
    if (!userId) return;
    const db = getDb();
    const doc = {
        userId,
        examId,
        title,
        score,
        totalQuestions,
        percentage,
        createdAt: serverTimestamp()
    };
    await addDoc(collection(db, 'progress_exam_results'), doc);
};

export const recordGeneration = async ({ kind, folderId, source, count }) => {
    const db = getDb();
    const doc = {
        userId: getUserId(),
        kind, // live | upload | foto
        folderId: folderId || null,
        source: source || null,
        count: typeof count === 'number' ? count : null,
        createdAt: serverTimestamp()
    };
    await addDoc(collection(db, 'progress_generations'), doc);
};


